import React, { useMemo, useState } from 'react'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'
import List from '@material-ui/core/List'
import Box from '@material-ui/core/Box'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import UserPopover from 'ui/modules/popover/userPopover'
import Avatar from 'ui/components/avatar'
import { ReactComponent as IconHomeCustom } from 'assets/icons/home-custom.svg'
import { ReactComponent as IconProviderCustom } from 'assets/icons/provider-custom.svg'
import { ReactComponent as IconSearchCustom } from 'assets/icons/search-custom.svg'
import SvgIcon from '@material-ui/core/SvgIcon'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const Menu = props => {
  const { open, user, onLogout } = props
  const t = useTranslation()

  const USER_ITEMS = [
    {
      title: t('menu:dashboard'),
      icon: IconHomeCustom,
      link: '/app',
      exact: true,
      extraClass: '',
    },
    {
      title: t('menu:your-providers'),
      icon: IconProviderCustom,
      link: '/app/vendors',
      extraClass: '',
    },
    {
      title: t('menu:searches'),
      icon: IconSearchCustom,
      link: '/app/searches',
      extraClass: '',
    },
  ]
  const LANDING_ITEMS = [
    {
      title: t('menu:login'),
      icon: false,
      link: '/login',
      exact: false,
      extraClass: 'menuActive',
    },
  ]

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  const userInitials = useMemo(() => {
    if (!user) return
    return `${user.first_name} ${user.last_name}`
      .split(' ')
      .map(str => str[0])
      .join('')
      .toLocaleUpperCase()
  }, [user])

  const classes = useStyles()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const menuItems = useMemo(() => (user ? USER_ITEMS : LANDING_ITEMS), [user])
  return (
    <>
      <List component="nav" className={classes.menu}>
        {menuItems.map(({ title, icon, link, exact, extraClass }) => (
          <ListItem
            key={link}
            button
            className={clsx(
              classes.menuButton,
              classes[extraClass],
              !open && classes.menuButtonClose,
            )}
            component={NavLink}
            to={link}
            exact={exact}
            activeClassName={classes.menuActive}
          >
            <ListItemIcon className={classes.menuButtonIcon}>
              {icon ? (
                <SvgIcon component={icon} />
              ) : (
                <Box width={24} height={24} />
              )}
            </ListItemIcon>
            <ListItemText primary={title} className={classes.menuButtonText} />
          </ListItem>
        ))}
      </List>
      {user ? (
        <>
          <List className={clsx(classes.menu, classes.menuSecondary)}>
            <ListItem
              button
              component="li"
              className={clsx(
                classes.menuButtonAvatar,
                !open && classes.menuButtonClose,
              )}
              onClick={handleClick}
            >
              <Avatar className={classes.menuAvatar}>{userInitials}</Avatar>
              <ListItemText
                primary={user.username}
                className={classes.userNameText}
              />
            </ListItem>
          </List>
          <UserPopover
            anchorEl={anchorEl}
            id={id}
            open={openPopover}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            avatarName={userInitials}
            user={`${user.first_name} ${user.last_name}`}
            email={user.username}
            onLogOut={onLogout}
          />
        </>
      ) : null}
    </>
  )
}

export default Menu
